import { GeographicArbitrageTile } from "../../components/dashboard/GeographicArbitrageTile.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";
import { FireSubPageLayout } from "./_layout.js";
import { useFireContext } from "./_use-fire-context.js";

/**
 * /fire/geographic-arbitrage — Phase 13.5 extraction.
 *
 * What the user's FI math looks like in lower-cost cities — moves the
 * COL multiplier and recomputes years-to-FI, target net-worth, and
 * implied withdrawal rate.
 */
export function FireGeographicArbitragePage() {
  useDocumentTitle("FIRE — Geographic arbitrage");
  const { hideValues, fiAssetsCents } = useFireContext();
  return (
    <FireSubPageLayout
      title="Geographic arbitrage"
      sub="What your FIRE numbers look like in lower-cost cities, and how much faster you'd hit FI."
    >
      <GeographicArbitrageTile
        hideValues={hideValues}
        fiAssetsCents={fiAssetsCents}
      />
      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireGeographicArbitrage} />
    </FireSubPageLayout>
  );
}
